var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPause = function SvgPause(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.917 7",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pause_svg__cls-1{fill:#275fe0}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause_svg__Gruppe_6011",
    "data-name": "Gruppe 6011",
    transform: "translate(-1661 -386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pause_svg__Rechteck_1182",
    width: 2,
    height: 7,
    className: "pause_svg__cls-1",
    "data-name": "Rechteck 1182",
    rx: 1,
    transform: "translate(1661 386)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "pause_svg__Rechteck_1183",
    width: 2,
    height: 7,
    className: "pause_svg__cls-1",
    "data-name": "Rechteck 1183",
    rx: 1,
    transform: "translate(1663.917 386)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export default ForwardRef;